import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=7b714ed4&scoped=true&"
import script from "./edit.vue?vue&type=script&lang=js&"
export * from "./edit.vue?vue&type=script&lang=js&"
import style0 from "./edit.vue?vue&type=style&index=0&id=7b714ed4&scoped=true&lang=css&"
import style1 from "./edit.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b714ed4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\CRM\\Client2026\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b714ed4')) {
      api.createRecord('7b714ed4', component.options)
    } else {
      api.reload('7b714ed4', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=7b714ed4&scoped=true&", function () {
      api.rerender('7b714ed4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cms/modifySupplement/edit.vue"
export default component.exports